import styled from 'styled-components';
import { getSizeBy } from '../../../src/styled/utils';
import { Overlay } from '../overlay';
import { StyledLoadingIndicator } from '../loading-indicator/styled';
export const StyledOverlay = styled(Overlay) `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;

  & > ${StyledLoadingIndicator} {
    margin-bottom: ${getSizeBy(7)};
  }
`;
